/**
 * Device + capability detection for the Public Viewer.
 *
 * Scrub mode policy (as of iter17):
 *   - "video" — drives `video.currentTime` from drag progress. Used on all
 *     devices since iter17. Works on desktop, modern Android Chrome, and
 *     iOS Safari (incl. Home-Screen PWA mode). Latency is dominated by the
 *     mp4's keyframe interval — content owners should re-encode with
 *     `-g 1` (every-frame-keyframe) for buttery seek.
 *   - "canvas" — pre-decoded ImageBitmap frames blitted to a canvas. Now
 *     reserved exclusively for *server-side pre-baked* image sequences
 *     (transition.image_sequence_urls), not as an iOS fallback. The old
 *     runtime decode path was unreliable on Safari and added multi-second
 *     waits the user could feel.
 *
 * If neither mode succeeds the engine signals failure and the viewer falls
 * back to a plain fade between scenes (no broken UX).
 */

export function isIOS() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return true;
  // iPadOS 13+ reports as Mac but is a touch device
  if (ua.includes("Mac") && navigator.maxTouchPoints > 1) return true;
  return false;
}

export function isSafari() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);
}

export function recommendScrubMode() {
  // Always video-mode for raw video transitions. Canvas-mode is gated at
  // the ScrubOverlay level on prebakedUrls being present.
  return "video";
}
